export function getMaterials(materials: string | undefined) {
  if (!materials) return []
  const auxMaterials = []
  let headerText = ''
  let startHeader = true
  let contentText = ''

  // each material starts with a header, which ends with ':' , we need to create an object with the header and the parts of the material
  for (let i = 0; i < materials.length; i++) {
    const currentChar = materials[i]
    const isNotCurrentCharSpace = materials[i] !== ' '
    const previousChar = materials[i - 1]
    const isPreviousCharComma = materials[i - 1] === ','
    // if the previous char is a comma and the current character is not a space, it indicates the end of the material.
    if (
      currentChar &&
      previousChar &&
      isNotCurrentCharSpace &&
      isPreviousCharComma
    ) {
      startHeader = true
      auxMaterials.push({ header: headerText, content: contentText })
      headerText = ''
      contentText = ''
    }
    if (startHeader) {
      headerText += materials[i]
      if (materials[i] === ':') {
        startHeader = false
      }
    } else {
      contentText += materials[i]
    }
  }
  if (headerText !== '' && contentText !== '') {
    auxMaterials.push({ header: headerText, content: contentText })
  } else if (headerText !== '') {
    auxMaterials.push({ header: '', content: headerText })
  }

  return auxMaterials
}
